// extracted by mini-css-extract-plugin
module.exports = {"summary":"styles_summary__ky_6J","divider":"styles_divider__GugzW"};